module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel",
    attrs: {
      "id": "task-list"
    }
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_vm._v(_vm._s(_vm.tokens['num_task'](_vm.tasks)))])]), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.openNewTextBox
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_new']))])])])])]), _c('div', {
    staticClass: "panel-block is-paddingless"
  }, [(_vm.tasks === null) ? _c('div', {
    staticClass: "container"
  }, [_c('loading')], 1) : _c('table', {
    staticClass: "table"
  }, [_c('tbody', _vm._l((_vm.tasks), function(task) {
    return _c('tr', {
      key: _vm.parent.id + task.id
    }, [_c('td', [_c('span', {
      staticClass: "is-inline-block"
    }, [_vm._v(_vm._s(task.name))]), (!!task.pages) ? _c('span', {
      staticClass: "is-inline-block"
    }, [_vm._v(" (" + _vm._s(_vm.tokens['lbl_pages'](task.pages.length)) + ")")]) : _vm._e()]), _c('td', {
      staticClass: "is-narrow"
    }, [_c('button', {
      staticClass: "button is-light",
      attrs: {
        "title": _vm.tokens['tit_edit'](_vm.isLocked(task.id)),
        "disabled": _vm.isLocked(task.id)
      },
      on: {
        "click": function($event) {
          _vm.edit(task)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-edit"
    })]), _c('button', {
      staticClass: "button is-light",
      attrs: {
        "title": _vm.tokens['tit_copy']
      },
      on: {
        "click": function($event) {
          _vm.copy(task)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-copy"
    })]), _c('button', {
      staticClass: "button is-danger",
      attrs: {
        "title": _vm.tokens['tit_delete']
      },
      on: {
        "click": function($event) {
          _vm.remove(task)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-trash-alt"
    })])])])
  }))])]), (_vm.isEditing) ? _c('modal-container', {
    attrs: {
      "title": _vm.taskEditorTitle
    },
    on: {
      "close": _vm.closeEditor
    }
  }, [_c('task-editor', {
    attrs: {
      "action": _vm.action,
      "task": _vm.toEdit,
      "source": _vm.toCopy,
      "intros": _vm.intros
    },
    on: {
      "save": _vm.save,
      "modified": _vm.onTaskModified
    }
  })], 1) : _vm._e(), (_vm.toDelete) ? _c('remove-warning', {
    attrs: {
      "object": "task",
      "name": _vm.toDeleteName
    },
    on: {
      "close": _vm.removeWarningClosed
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tokens['msg_delete_warning']) + ". ")])]) : _vm._e(), _c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b33b144"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/TaskList.vue
// module id = 413
// module chunks = 0